<template>
  <div v-if="repository">
    <i v-if="github" class="mdi mdi-github" />

    <template v-if="instance">
      <el-button
        type="text"
        :size="size"
        @click="$router.push('/instances/' + instance.id)"
      >
        {{ instance.name }}
      </el-button> /
    </template>

    {{ title }}
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    repositoryId: String,
    size: {
      type: String,
      default: 'medium'
    }
  },
  computed: {
    github () {
      return this.repository.github
    },
    clone () {
      return 'git clone git@' + this.instance.hostname + ':' + this.repository.name
    },
    title () {
      return this.github ? this.github.fullName : this.repository.name
    },
    instance () {
      return this.instances.find((i) => i.id === this.repository.instanceId)
    },
    repository () {
      return this.repositories.find((r) => r.id === this.repositoryId)
    },
    ...mapState(['instances', 'repositories'])
  }
}
</script>

<style lang="scss" scoped>
  .el-button {
    padding: 0 !important;
  }
</style>
